module.exports = __webpack_public_path__ + "static/media/liquor_germany.67ba0a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/liquor_germany.jpg
// module id = 456
// module chunks = 0